/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterSubmissionsQueryDto
 */
export interface FilterSubmissionsQueryDto {
    /**
     * Filter by insured
     * @type {Array<string>}
     * @memberof FilterSubmissionsQueryDto
     */
    insureds?: Array<string>;
    /**
     * Filter by transaction type
     * @type {Array<string>}
     * @memberof FilterSubmissionsQueryDto
     */
    transactionTypes?: Array<FilterSubmissionsQueryDtoTransactionTypesEnum>;
    /**
     * Filter by assigned handlers
     * @type {Array<string>}
     * @memberof FilterSubmissionsQueryDto
     */
    assignedHandlerIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FilterSubmissionsQueryDto
     */
    includeLayers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterSubmissionsQueryDto
     */
    includeContracts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterSubmissionsQueryDto
     */
    includeInsured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterSubmissionsQueryDto
     */
    includeUnderwriter?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FilterSubmissionsQueryDto
     */
    prefetchChangelogs?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterSubmissionsQueryDto
     */
    statuses?: Array<FilterSubmissionsQueryDtoStatusesEnum>;
}


/**
 * @export
 */
export const FilterSubmissionsQueryDtoTransactionTypesEnum = {
    Renewal: 'Renewal',
    NewBusiness: 'New Business'
} as const;
export type FilterSubmissionsQueryDtoTransactionTypesEnum = typeof FilterSubmissionsQueryDtoTransactionTypesEnum[keyof typeof FilterSubmissionsQueryDtoTransactionTypesEnum];

/**
 * @export
 */
export const FilterSubmissionsQueryDtoStatusesEnum = {
    Prospect: 'Prospect',
    Pending: 'Pending',
    Quoted: 'Quoted',
    Declined: 'Declined',
    Cancelled: 'Cancelled',
    Complete: 'Complete'
} as const;
export type FilterSubmissionsQueryDtoStatusesEnum = typeof FilterSubmissionsQueryDtoStatusesEnum[keyof typeof FilterSubmissionsQueryDtoStatusesEnum];


/**
 * Check if a given object implements the FilterSubmissionsQueryDto interface.
 */
export function instanceOfFilterSubmissionsQueryDto(value: object): value is FilterSubmissionsQueryDto {
    return true;
}

export function FilterSubmissionsQueryDtoFromJSON(json: any): FilterSubmissionsQueryDto {
    return FilterSubmissionsQueryDtoFromJSONTyped(json, false);
}

export function FilterSubmissionsQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterSubmissionsQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insureds': json['insureds'] == null ? undefined : json['insureds'],
        'transactionTypes': json['transactionTypes'] == null ? undefined : json['transactionTypes'],
        'assignedHandlerIds': json['assignedHandlerIds'] == null ? undefined : json['assignedHandlerIds'],
        'includeLayers': json['includeLayers'] == null ? undefined : json['includeLayers'],
        'includeContracts': json['includeContracts'] == null ? undefined : json['includeContracts'],
        'includeInsured': json['includeInsured'] == null ? undefined : json['includeInsured'],
        'includeUnderwriter': json['includeUnderwriter'] == null ? undefined : json['includeUnderwriter'],
        'prefetchChangelogs': json['prefetchChangelogs'] == null ? undefined : json['prefetchChangelogs'],
        'statuses': json['statuses'] == null ? undefined : json['statuses'],
    };
}

export function FilterSubmissionsQueryDtoToJSON(json: any): FilterSubmissionsQueryDto {
    return FilterSubmissionsQueryDtoToJSONTyped(json, false);
}

export function FilterSubmissionsQueryDtoToJSONTyped(value?: FilterSubmissionsQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insureds': value['insureds'],
        'transactionTypes': value['transactionTypes'],
        'assignedHandlerIds': value['assignedHandlerIds'],
        'includeLayers': value['includeLayers'],
        'includeContracts': value['includeContracts'],
        'includeInsured': value['includeInsured'],
        'includeUnderwriter': value['includeUnderwriter'],
        'prefetchChangelogs': value['prefetchChangelogs'],
        'statuses': value['statuses'],
    };
}

